import { Action } from '@ngrx/store';
import { SimpleNotification } from '../../shared/components/simple-notification/models/SimpleNotification.model';

// Constants
export const PROJECT_VIEW = '[Core - UI] Project Dashboard View';
export const COLLAPSE_SIDEBAR = '[Core - UI] Collapse Sidebar';
export const START_OR_STOP_SEARCH = '[Core - UI] Start Or Stop Search';
// Constants - Autosave
export const AUTO_SAVED = '[Core - Autosave] Auto saved';
export const AUTO_SAVING = '[Core - Autosave] Auto saving';
export const CLEAR_AUTO_SAVE = '[Core - Autosave] Clear';
// Constants - App Language
export const LANGUAGE_CHANGE = '[Core - Language] Language Change';
// Constants - Project Section Selected
export const PROJECT_SECTION_SELECTED = '[Core - Project] Section Selected';
// Simple Notification
export const ADD_SIMPLE_NOTIFICATION = '[Core - Simple Notification] Simple Notification';
export const CLEAR_SIMPLE_NOTIFICATIONS = '[Core - Simple Notification] Clear Simple Notifications';
export const REMOVE_SIMPLE_NOTIFICATION = '[Core - Simple Notification] Remove Simple Notification';

// Actions
export class ProjectView implements Action {
  readonly type = PROJECT_VIEW;
  constructor(public payload: boolean) {}
}
export class StartSearch implements Action {
  readonly type = START_OR_STOP_SEARCH;
}
export class CollapseSidebar implements Action {
  readonly type = COLLAPSE_SIDEBAR;
}
// Actions - Autosave
export class AutoSaved implements Action {
  readonly type = AUTO_SAVED;
}
export class AutoSaving implements Action {
  readonly type = AUTO_SAVING;
}
export class ClearAutosave implements Action {
  readonly type = CLEAR_AUTO_SAVE;
}
// Actions - App Language
export class LanguageChange implements Action {
  readonly type = LANGUAGE_CHANGE;
  constructor(public payload: string) {}
}
// Actions - Project Section Selected
export class SelectProjectSection implements Action {
  readonly type = PROJECT_SECTION_SELECTED;
  constructor(public payload: string) {}
}

export class AddSimpleNotification implements Action {
  readonly type = ADD_SIMPLE_NOTIFICATION;
  constructor(public payload: SimpleNotification) {}
}

export class ClearSimpleNotifications implements Action {
  readonly type = CLEAR_SIMPLE_NOTIFICATIONS;
}

export class RemoveSimpleNotification implements Action {
  readonly type = REMOVE_SIMPLE_NOTIFICATION;
  constructor(public payload: SimpleNotification) {}
}


// Export Actions
export type Actions =
  | AutoSaved
  | AutoSaving
  | ProjectView
  | StartSearch
  | ClearAutosave
  | LanguageChange
  | CollapseSidebar
  | SelectProjectSection
  | AddSimpleNotification
  | ClearSimpleNotifications
  | RemoveSimpleNotification;



// WEBPACK FOOTER //
// ./src/app/core/actions/ui.actions.ts